import {
  Avatar,
  Box,
  Flex,
  Image,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import React from "react";
import InviteBg from "../../assets/images/invite-bg.png";
import WDSLogo from "../../assets/images/wds-logo.png";
import GMI from "../../assets/images/arabic-2.png";
import BadgeIcon from "../../assets/images/badge-icon.png";
import CustomText from "../../components/text/CustomText";
import QRCode from "react-qr-code";

function InviteCard({ isLoading, user }: any) {
  return (
    <Flex
      flexDir="column"
      justify="space-between"
      minW="411px"
      bg="#F2F2F2"
      borderRadius="24px"
    >
      <Box>
        <Box
          pos="relative"
          bgImage={`url(${InviteBg})`}
          bgSize="cover"
          bgRepeat="no-repeat"
          bgPos="center"
          h="200px"
          borderTopRadius="24px"
        >
          <Flex p="12px 6px" justify="space-between">
            <Image src={WDSLogo} alt="wds" w="80px" h="38px" />
            <Image src={GMI} alt="wds" w="116px" h="67px" />
          </Flex>
        </Box>
        <Box
          bg="yess.secondary_gold"
          w="224px"
          h="135px"
          borderRadius="274px"
          mx="auto"
          mt="-125px"
        />
        <Flex justify="center" flexDir="column" align="center">
          {isLoading ? (
            <SkeletonCircle size="150px" mt="-80px" />
          ) : (
            <Avatar
              src={user?.profileImg}
              name={user?.personalInfo?.name}
              bg="yess.secondary_gold"
              border="5px solid #F2F2F2"
              boxSize="150px"
              mt="-80px"
            />
          )}
          <Avatar src={BadgeIcon} boxSize="28px" mt="-15px" />
          {isLoading ? (
            <SkeletonText noOfLines={1} w="120px" />
          ) : (
            <CustomText
              text={user?.personalInfo?.name}
              size="24px"
              weight="700"
              color="#001C70"
            />
          )}
          {isLoading ? (
            <SkeletonText noOfLines={1} w="120px" />
          ) : (
            <CustomText
              text={`${
                user?.personalInfo?.jobTitle || user?.companyInfo?.jobTitle
              }, ${user?.companyInfo?.companyName}`}
              size="14px"
              color="yess.neutral700"
            />
          )}
        </Flex>
      </Box>{" "}
      <Flex justify="center">
        {isLoading ? (
          <Skeleton w="150px" h="150px" />
        ) : (
          <QRCode
            value={`${user?.personalInfo?.name}, (${
              user?.personalInfo?.jobTitle || user?.companyInfo?.jobTitle
            } at ${user?.companyInfo?.companyName})`}
            bgColor="transparent"
            size={150}
          />
        )}
      </Flex>
      <Flex flexDir="column" align="center" gap="10px">
        {isLoading ? (
          <SkeletonText noOfLines={1} w="120px" />
        ) : (
          <CustomText
            text={user?.badge?.validFor}
            color="#ED3D4E"
            size="12px"
            family="gotham-bold"
          />
        )}
        <Flex
          h="42px"
          borderBottomRadius="24px"
          bg="#A5A1A1"
          align="center"
          justify="center"
          w="100%"
        >
          {isLoading ? (
            <SkeletonText noOfLines={1} w="120px" />
          ) : (
            <CustomText
              text={user?.badge?.type}
              size="18px"
              color="#fff"
              weight="700"
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}

export default InviteCard;
